import { useMutation } from "@tanstack/react-query";
import { rmPdCreateApi, rmPdInfApi, rmPdsApi } from "components/api/rm";
import { PAGE_ID_ROOM_PRODUCT } from "components/constent";
import {
  getDay,
  pageInitInf,
  timeFormat,
  apifield,
  initialPageNav,
} from "components/utils/comm";
import { IPageNav } from "interface/index";
import { IRmOps, IRmPdInf, IRmPds } from "interface/rm/rmpd";
import i18n from "locales/i18n";
import { FormEvent, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import useAlertStore from "store/alert";
import useListRowInfStroe from "store/listRowInf";
import useLodStore from "store/lod";
import usePageNoStore from "store/pageNo";
import {
  useCreatePrudoctParamContext,
  useProductParamsContext,
} from "./context";

// 객실 상품리스트 조회
type ISearch = {
  param: any;
};

export const useSearchList = () => {
  const { t } = useTranslation();
  const langCd = i18n.language;
  const pageNo = usePageNoStore((state) => state.pageNo);
  const resetPageNo = usePageNoStore((state) => state.resetPageNo);
  const { param } = useProductParamsContext();

  const [rowData, setRowData] = useState<any[] | null>(null);
  const pageNavRef = useRef<IPageNav>(initialPageNav);

  const today = new Date().toISOString().split("T")[0].replaceAll("-", "");

  const mutation = useMutation({
    mutationKey: ["room-product-search"],
    mutationFn: rmPdsApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          //예약리스트 조회
          const pageNav = data.pageNav;
          pageNavRef.current = data.pageNav;
          const rmPdList = data.rmPdList.map((rmPd: IRmPds, index: number) => {
            return {
              ...rmPd,
              No: (pageNav.pageNo - 1) * pageNav.pageRows + index + 1,
              sellYnNm:
                Number(rmPd.sellDt) > Number(today)
                  ? rmPd.sellYn === "Y"
                    ? t("status_sell_y")
                    : t("status_sell_n")
                  : t("status_sell_end"),
              day: getDay({ dayNm: "", date: rmPd.sellDt, langCd }),
              latChkOutTi: timeFormat(rmPd.latChkOutTi),
              brkfInYnNm:
                rmPd.brkfInYn === "Y" ? t("included_y") : t("included_n"),
            };
          });
          setRowData(rmPdList);
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });

  useEffect(() => {
    if (param) {
      mutation.mutate({
        ...param,
        ...pageInitInf,
      });
      resetPageNo();
    }
  }, [param]);

  // NextPage

  const isCurrent = pageNo?.target === PAGE_ID_ROOM_PRODUCT;

  useEffect(() => {
    if (isCurrent) {
      const params = {
        ...param,
        pageNo: pageNo?.no || 1,
        pageRows: pageNo?.pageRows,
      };

      mutation.mutate(params);
    }
  }, [pageNo?.no, pageNo?.pageRows]);

  return {
    rowData,
    pageNav: pageNavRef.current,
  };
};

// 객실 상품상세 조회
export const useGetData = () => {
  const listRowInf = useListRowInfStroe((state) => state.listRowInf);
  const rmPdInfRef = useRef<IRmPdInf | null>(null);
  const rmOpNmListRef = useRef<IRmOps[] | null>(null);

  const mutation = useMutation({
    mutationKey: ["room-product-detail"],
    mutationFn: rmPdInfApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          rmPdInfRef.current = res.data.rmPdInf;
          rmOpNmListRef.current = res.data.rmOpNmList;
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });

  useEffect(() => {
    if (listRowInf.no) {
      mutation.mutate(listRowInf.no);
    }
  }, [listRowInf.no]);

  return {
    rmPdInf: rmPdInfRef.current,
    rmOpNmList: rmOpNmListRef.current,
    isLoading: mutation.isPending,
    isSuccess: mutation.isSuccess,
  };
};

// 객실상품 등록
export const useCreateProductMutate = () => {
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  const { onReset } = useCreatePrudoctParamContext();
  return useMutation({
    mutationKey: ["room-product-create"],
    mutationFn: rmPdCreateApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;

        if (code === 0) {
          // 등록 성공
          onSetAlert({
            isOpen: true,
            inner: "객실상픔을 성공적으로 등록하였습니다.",
            onSetConfirm: () => {
              onReset();
            },
          });
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });
};

export const useBaseSubmitForm = () => {
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  const lod = useLodStore((state) => state.lod);
  const { param } = useCreatePrudoctParamContext();
  const { mutate } = useCreateProductMutate();
  const onBaseSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;

    // ❌ validation 실패
    if (!form.checkValidity()) {
      form.reportValidity(); // required 문구 표시
      return;
    }

    onSetAlert({
      isOpen: true,
      inner: "객실상품을 등록하시겠습니까?",
      cnclBtn: true,
      onSetConfirm: () => {
        mutate({
          ...param,
          lodNo: lod?.lodNo,
          rmPdCt: Number(param.rmPdCt),
          rmPdSellPri: Number(
            param?.rmPdSellPri?.toString().replaceAll(",", "")
          ),
        });
      },
    });
    // const form = e.currentTarget;
    // if (!form) return;

    // const formData = getFormData({ form, type: "C" });

    // 필수입력값 확인

    // onSetAlert({
    //   isOpen: true,
    //   inner: "객실상품을 등록하시겠습니까?",
    //   cnclBtn: true,
    //   onSetConfirm: () => {
    //     let rmPdAplyDow = "";
    //     let data = {} as any;
    //     Object.keys(formData).forEach((key) => {
    //       if (key.includes("day")) {
    //         rmPdAplyDow += formData[key];
    //       }
    //       if (!key.includes("day")) {
    //         data =
    //           key !== "rgSeq"
    //             ? {
    //                 ...data,
    //                 [key]: formData[key],
    //               }
    //             : {
    //                 ...data,
    //                 rmOpSeq: formData[key],
    //               };
    //       }
    //     });
    //     const params = {
    //       ...data,
    //       rmPdAplyDow,
    //       lodNo: lod?.lodNo,
    //     };

    //     mutate(params);
    //   },
    // });
  };

  return {
    onBaseSubmit,
  };
};
